import React, { useEffect, useState } from 'react';
import { Location, useLocation } from 'react-router-dom';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { Spinner } from '@leagueplatform/genesis-core';
import { captureError } from '@leagueplatform/observability';
import { ErrorState } from '@leagueplatform/web-common-components';
import { FullScreenContainer } from 'components/full-screen-container/full-screen-container.component';
import { CS_AUTH0_CLIENT_CONNECTION } from 'tenant-configs/contants';
import { captureAuthenticationError } from './capture-auth-error.component';

// Gets auth0 error returned from redirect, the returned error could be a query param or a hash param
const getAuth0ErrorIfExists = (location: Location) => {
  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(location.hash.replace(/#/g, '?'));

  const type = searchParams.get('error') || hashParams.get('error');
  const description =
    searchParams.get('error_description') ||
    hashParams.get('error_description');

  if (type) {
    return { type, description };
  }

  return null;
};

export const CSAuthSignIn = () => {
  const location = useLocation();

  const [error, setError] = useState('');

  useEffect(() => {
    const connection =
      new URLSearchParams(location.search).get('connection') ||
      CS_AUTH0_CLIENT_CONNECTION;

    const authError = getAuth0ErrorIfExists(location);
    if (authError) {
      setError(`${authError.type}: ${authError.description || ''}`);
      captureAuthenticationError(authError);
      return;
    }

    try {
      const options = {
        connection,
      };

      StandaloneAuth.client.loginWithRedirect(options);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : String(e));
      captureError(new Error('Error logging into CS app'), {
        context: {
          'Response Info': {
            response: e,
          },
        },
      });
    }
  }, [location]);

  if (error) {
    return (
      <FullScreenContainer backgroundColor="surface.background.primary">
        <ErrorState bodyString={error} hideButton error={null} />
      </FullScreenContainer>
    );
  }
  return <Spinner loading />;
};
